/**
 * Copyright 2018 Phenix Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
define([
    'phenix-web-lodash-light',
    'pbf',
    './Schema',
    './mqProto.json'
], function(_, Pbf, Schema, mqProto) {
    'use strict';

    function MQProtocol(protocols, apiVersion) {
        var that = this;

        this._schemas = {};

        this._schemas[mqProto.package] = new Schema(mqProto);

        _.forEach(protocols, function(protocol) {
            that._schemas[protocol.package] = new Schema(protocol);
        });

        this._apiVersion = apiVersion || 3;
    }

    MQProtocol.prototype.getApiVersion = function() {
        return this._apiVersion;
    };

    MQProtocol.prototype.encode = function(type, data) {
        if (typeof type !== 'string') {
            throw new Error("'type' must be a string");
        }

        if (typeof data !== 'object') {
            throw new Error("'data' must be an object");
        }

        var typeQuery = type.split('.');
        var namespace = _.get(typeQuery, [0]);
        var subType = _.get(typeQuery, [1]);
        var schema = _.get(this._schemas, [namespace]);
        var message = new Pbf();

        schema.write(subType, data, message);

        return message.finish();
    };

    MQProtocol.prototype.decode = function(type, value) {
        if (typeof type !== 'string') {
            throw new Error("'type' must be a string");
        }

        var typeQuery = type.split('.');
        var namespace = _.get(typeQuery, [0]);
        var subType = _.get(typeQuery, [1]);
        var schema = _.get(this._schemas, [namespace]);
        var message = new Pbf(value);
        var decodedMessage = schema.read(subType, message);

        return decodedMessage;
    };

    return MQProtocol;
});